import React, { useState, useEffect } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Grid,
  TextField,
  Checkbox,
  Backdrop,
  CircularProgress
} from '@material-ui/core';
import { Autocomplete } from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { tr } from 'date-fns/locale';
import format from 'date-fns/format';
import axios from 'src/utils/axios';
import { getUser } from 'src/utils/Common';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import { getDate, isValid, parse } from 'date-fns';



const ReferansTarihiDialog = ({ open, onClose, classes }) => {
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [confirmOpen, setConfirmOpen] = useState(false);
  const SessionUser = getUser();
  const [selectedbolgeAdiKoduFormForConfirm, setSelectedbolgeAdiKoduFormForConfirm] = React.useState([]);
  const [SelectedBirimForConfirm, setSelectedBirimForConfirm] = React.useState([]);
  const [BirimDataForConfirm, setBirimDataForConfirm] = React.useState([]);
  const [bolgeAdiKodu, setBolgeAdiKodu] = React.useState([]);
  const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
  const checkedIcon = <CheckBoxIcon fontSize="small" style={{ color: '#FF9800' }} />;
  const SelectAllOption = { BirimKodu: 0, Dsc: 'Tümü' };
  const [loading, setLoading] = useState(false);
  const [BirimData, setBirimData] = React.useState([]);
  const [berataUygunMu, setBerataUygunMu ] = React.useState(false);

  useEffect(() => {
        setLoading(true);
        getBolgeAdiKoduData();
        setLoading(false);
   }, []);

   useEffect(() => {
        setLoading(true);
        if(SelectedBirimForConfirm.BirimKodu > 0)
          getReferansTarihi();
        setLoading(false);
   }, [SelectedBirimForConfirm]);

  const handleConfirmClick = () => {
    if (selectedDate) {
      setConfirmOpen(true);
    }
  };

  const getReferansTarihi = () => {   
    axios
      .get(`GetYSReferansDate?BirimKodu=${SelectedBirimForConfirm.BirimKodu}`)
      .then((response) => {
        if(response.data.length > 0){
            debugger;
            const parsedDate = parse(response.data, 'dd-MM-yyyy', new Date());
            const formattedDate = format(parsedDate, 'dd-MM-yyyy');
            if (formattedDate === '01-01-1900') {
              alert('Bu servis berat için uygun değil');
              setBerataUygunMu(false);
            }else{
              setBerataUygunMu(true);
            }
            setSelectedDate(parsedDate);
          }
      })
      .catch(() => {
        alert("Sunucuya bağlanırken bir hata oluştu.");
      });
  };

  const handleActualConfirm = () => {
    const formattedDateForSQL = format(selectedDate, 'yyyy-MM-dd');
    axios
      .post(`SetYSRefDate?RefTarihi=${formattedDateForSQL}&BirimKodu=${SelectedBirimForConfirm.BirimKodu}`)
      .then((response) => {
        if (response.data.ErrorCode === "0") {
          setSelectedDate(new Date());
          setConfirmOpen(false);
          setSelectedBirimForConfirm([]);
          setSelectedbolgeAdiKoduFormForConfirm([]);
          setBerataUygunMu(false);
          onClose();
        } else {
          alert("İşlem sırasında bir hata oluştu.");
        }
      })
      .catch(() => {
        alert("Sunucuya bağlanırken bir hata oluştu.");
      });
  };

  const handleCancel = () => {
    //setSelectedDate(null);
    setSelectedBirimForConfirm([]);
    setSelectedbolgeAdiKoduFormForConfirm([]);
    setSelectedDate(new Date());
    setConfirmOpen(false);
    setBerataUygunMu(false);
    onClose();
  };

  const getBirimDataForConfirm = (BirimKodu) => {
          if (!BirimKodu || BirimKodu.length < 1) {
              setBirimData([]);
          } else {
              setLoading(true);
              axios.get(`GetBirimDataCokBolgeli?BirimKodu=${BirimKodu.join("&BirimKodu=")}`).then((response) => {
                  setBirimDataForConfirm([SelectAllOption, ...response.data]);
                  setLoading(false);
              });
          }
      }

    const getBolgeAdiKoduData = () => {
        axios.get(`GetBolgeAdiKodu/${SessionUser.TopServiceShopCode}`).then((response) => {
            setBolgeAdiKodu(response?.data);
        })

    }
      const renderOption = (props, option, { selected }) => (
              <li {...props}>
                  <Checkbox
                      icon={icon}
                      checkedIcon={checkedIcon}
                      style={{ marginRight: 8 }}
                      checked={selected}
                  />
                  {option.Dsc}
              </li>
          );

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={tr}>
      <Dialog open={open} onClose={handleCancel} fullWidth maxWidth="sm">
        <DialogTitle>Referans Tarihi Girme</DialogTitle>
        <Backdrop  className={classes.backdrop} open={loading}>
                        <CircularProgress color="inherit" />
        </Backdrop>
        <DialogContent>
            <Grid>
                <Grid item>
                    <Autocomplete
                        multiple
                        limitTags={1}
                        size="small"
                        id="combo-box-demo"
                        fullWidth
                        value={selectedbolgeAdiKoduFormForConfirm}
                        options={bolgeAdiKodu.length > 0 ? bolgeAdiKodu : []}
                        getOptionLabel={option => (option.Dsc ? option.Dsc : '')}
                        renderOption={renderOption}
                        onChange={(event, newValue) => {
                            setSelectedbolgeAdiKoduFormForConfirm(newValue);
                            var bolgeKodu = newValue?.find(x => x.BirimKodu == 0) ? bolgeAdiKodu.map(x => x.BirimKodu) : newValue.map(x => x.BirimKodu);
                            getBirimDataForConfirm(bolgeKodu);
                            setSelectedBirimForConfirm([]);
                        }}
                        renderInput={(params) => <TextField {...params} label="Bölge" variant="outlined" />}
                    />
                </Grid>
                <br></br>
                <Grid >
                    <Autocomplete
                        limitTags={1}
                        size="small"
                        id="combo-box-demo"
                        fullWidth
                        value={SelectedBirimForConfirm}
                        options={BirimDataForConfirm.length > 0 ? BirimDataForConfirm : []}
                        getOptionLabel={option => (option.Dsc ? option.Dsc : '')}
                        renderOption={renderOption}
                        onChange={(event, newValue) => {
                            setSelectedBirimForConfirm(newValue || []);
                        }}
                        renderInput={(params) => <TextField {...params} label="Servis" variant="outlined" />}
                    />
                </Grid>
            </Grid>
            <br></br>
          <DatePicker
            label="Tarih Seçiniz"
            value={selectedDate}
            onChange={(newDate) => setSelectedDate(newDate)}
            format="dd.MM.yyyy"  
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCancel} color="error">
            İptal
          </Button>        
          <Button
            onClick={handleConfirmClick}           
            color="primary"
            disabled={!isValid(selectedDate) || !(SessionUser.Role_Id === 1 || SessionUser.Role_Id === 3) || !berataUygunMu}
          >
            Onayla
          </Button>
          
        </DialogActions>
      </Dialog>

      {/* Onay Dialogu */}
      <Dialog
        open={confirmOpen}
        onClose={() => setConfirmOpen(false)}
      >
        <DialogTitle>Onayla</DialogTitle>
        <DialogContent>
          <Typography>
            {isValid(selectedDate) && (
              <strong>{format(selectedDate, 'dd.MM.yyyy')} tarihini seçtiniz. </strong> 
              ) }
          </Typography>
          <Typography sx={{ mt: 1 }}>
            Bu tarih baz alınarak servisin referans tarihi güncellenecek. Emin misiniz?
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setConfirmOpen(false)} color="error">
            İptal
          </Button>
          <Button onClick={handleActualConfirm} variant="contained" color="primary" style={{ backgroundColor: '#f57c00', color: '#fff' }}>
            Evet
          </Button>
        </DialogActions>
      </Dialog>
    </LocalizationProvider>
  );
};

export default ReferansTarihiDialog;
